import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../policy/fragments/heading";
import { Link, useHistory, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { useState } from "react";
import { useCallback } from "react";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useSelector } from "react-redux";
import { useStore } from "react-redux";
import { useQuery } from "../../../../hooks/common";
import { useEffect } from "react";
import NormalConfigConfirm from "../../../../components/alert/config-confirm";
import MeLoading from "../../components/loading";
import { fetchConfirmEmail } from "../../../../../api";
import { action_fetch_points_guide } from "../../../../../store/actions/pages/customer";

const PointsGuide = props =>{
    useStyles(cls);
    const Intl = useIntl();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { customer, pointsGuide } = pageCustomer;
    const store = useStore();
    const params = useParams();
    const query = useQuery();
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await PointsGuide.fetchData(store, params, query)
		}
    }, []);

    const disposePath = useCallback((type) =>{
        let str;
        switch(type){
            case 1:
                str = "/user/my-measurements";
                break;
            case 2:
                str = "/user/my-preference";
                break;
        }

        return str;
    }, []);

    const disposeClick = useCallback((type) =>{
        switch(type){
            case 3:
                handleClick();
                break;
            default:
                break;
        }
    }, []);

    const ifOwnEmail = useCallback((email) =>{
        return email?.endsWith("@chic-fusion.com") || email?.endsWith("@ivrose.com") || email?.endsWith("@boutiquefeel.com")
    }, [])

    const handleClick = useCallback(async () =>{
        if(ifOwnEmail(customer?.email)){
            history.push('/user/change-email');
        }else{
            let message;
            if(!customer?.isConfirmEmail){
                setLoading(true);
                let response = await fetchConfirmEmail(customer?.email);
                setLoading(false);
                if(response?.code === 200){
                    message = "A verification link has been sent to your email address, please check your mailbox.";
                }else{
                    message = response?.result || "Sorry, your operations are too busy, please try again later";
                }
            }else{
                message = "Your email has been verified, please use other ways to get points.";
            }
            NormalConfigConfirm({
                btn1:{
                    text:Intl.formatMessage({ id: "ok", defaultMessage: "OK" })
                },
                message:{
                    text:message,
                    style:{
                        lineHeight:'normal'
                    }
                }
            });
        }
    }, [customer]);

    return <div className={cls.PointsGuide}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "my_points", defaultMessage: "My Points" })} 
            rightSlot={
                <a href="/policy/bonus-point" className={cls.RightIcon}>
                    <Iconfont className={cls.Icon}>&#xe73f;</Iconfont>
                </a>
            }
        />

        {
            pointsGuide?.filter((data)=>!data?.isApp).map((item, index) =>{
                if(!disposePath(item?.type)){
                    return <a className={cls.GuideLink} onClick={()=>disposeClick(item.type)}>
                        <div className={cls.Hd}>
                            {item?.title}
                        </div>

                        <div className={cls.Bd}>
                            <p className={cls.Font}>{item?.content}</p>
                        </div>
                    </a>
                }else{
                    return <Link to={disposePath(item?.type)} className={cls.GuideLink}>
                        <div className={cls.Hd}>
                            {item?.title}
                        </div>

                        <div className={cls.Bd}>
                            <p className={cls.Font}>{item?.content}</p>
                        </div>
                    </Link>
                }
            })
        }

        <MeLoading loading={loading} />
    </div>
}

PointsGuide.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_points_guide(headers))
}

export default PointsGuide;